import { render, staticRenderFns } from "./FaqAndSupportDirectionsMobile.vue?vue&type=template&id=399d2d64&scoped=true"
import script from "./FaqAndSupportDirectionsMobile.vue?vue&type=script&lang=js"
export * from "./FaqAndSupportDirectionsMobile.vue?vue&type=script&lang=js"
import style0 from "./FaqAndSupportDirectionsMobile.vue?vue&type=style&index=0&id=399d2d64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399d2d64",
  null
  
)

export default component.exports